module.exports = "https://99designs-start-assets.imgix.net/js/61b6546ef1a1e23d72a7d674fbe271be.png";